import Widgets from '@/widgets'

const required = (val) => val !== null && val !== undefined && val !== '';
const maxLength = (val, max) => val.length <= max;

export default [
	{name:'title',       widget:Widgets.input,         attrs: { type:'text',   required:true, placeholder:"Заголовок доклада", }, },
	{name:'description', widget:Widgets.textareaCount, attrs: { type:"text",   required:true,  placeholder:"Аннотация (не менее 800 знаков)", rows:3, }, validators: [{type:required, value:true}] },
	// {name:'attachment',  widget:Widgets.file,          attrs: { type:'file',   required:false, placeholder:"Выберите доклад (файл)", }, },
	// {name:'category_id', widget:Widgets.selectSimple,  attrs: { type:'select', required:true, placeholder:"Секция", }, default:{value: null, text: 'Выберите секцию'}, options: []},
	{name:'category_id', widget:Widgets.select,  attrs: { type:'select', required:false, placeholder:"Секция", 'value-field':"id", 'text-field':"title" }, options: []},

	/*{
		name:'category_id',
		widget:Widgets.extraSelect2,
		// label:'Category',
		attrs: {
			type:'select', required:true, placeholder:"Выберите секцию", multiple:false,
			'group-values':"values",
			'group-label':"cat_type",
		},
		// help:'choose select please',
		options: [
			// {value: null, title: 'Выберите секцию'},
			{
				cat_type: 'test heading',
				values: [{value: 1, title: 'test1'}, {value: 2, title: 'test2'}],
			}],
	},*/
]
